<template>
	<div>
		<!-- 面包导航 -->
		<el-breadcrumb separator="/" style="padding-left:10px;padding-bottom:10px;font-size:12px;">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>主数据配置</el-breadcrumb-item>
		</el-breadcrumb>
<div 
		<el-card class="left" style="width: 16%;height: 730px;float: left;overflow:auto;">
			<el-tree :data="data1" :props="defaultProps" @node-click="handleNodeClick" :default-expand-all="true"></el-tree>
		</el-card>

		<el-card class="right" style="width: 82%;float: right;height: 630px; height: 300px;position: relative;">
			<div style="overflow: hidden;">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane label="基本信息" name="first">
						<el-form label-width="100px">
							<el-form-item :label= "$t('message.table.name')" prop="name" :required="false" style="width: 45%;float: left;">
								<el-input style="" value="变压器"></el-input>
							</el-form-item>
							<el-form-item label="描述" prop="description" :required="false" style="width: 45%;float: left;">
								<el-input style=";" value="变压器"></el-input>
							</el-form-item>							
							<el-form-item style="width: 100%;float: left;">
								<el-button type="primary" >{{$t('message.button.release')}}</el-button>
								<el-button >{{$t('message.button.reset')}}</el-button>
							</el-form-item>
						</el-form>						
					</el-tab-pane>
					<el-tab-pane label="页签" name="second">
						<el-table size="small" stripe :data="TabsData" style="width: 100%;margin-top:20px;"
						 height="200">
							<el-table-column prop="col1" :label= "$t('message.table.name')" width="100"></el-table-column>
							<el-table-column prop="col2" label="描述"></el-table-column>
							<el-table-column prop="col3" label="可见"></el-table-column>
						</el-table>					
					</el-tab-pane>
					<el-tab-pane label="生命周期" name="third">
						<el-table size="small" stripe :data="LifecycleData" style="width: 100%;margin-top:20px;"
						 height="200">
							<el-table-column prop="col1" :label= "$t('message.table.name')" width="100"></el-table-column>
							<el-table-column prop="col2" label="描述"></el-table-column>
							<el-table-column prop="col3" label="可用"></el-table-column>
						</el-table>							
					</el-tab-pane>
					<el-tab-pane label="操作历史" name="fourth">
						<el-table size="small" stripe :data="HistoryData" style="width: 100%;margin-top:20px;"
						 height="200">
							<el-table-column prop="col1" label="操作" width="100"></el-table-column>
							<el-table-column prop="col2" label="对象"></el-table-column>
							<el-table-column prop="col3" label="用户"></el-table-column>
							<el-table-column prop="col4" label="时间"></el-table-column>
							<el-table-column prop="col5" label="详细信息"></el-table-column>
						</el-table>	
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
		
		<el-card class="right" style="width: 82%;float: right;height: 630px; height: 400px;margin-top: 24px;">
			<div style="overflow: hidden;">
				<el-tabs v-model="activeName2" type="card" @tab-click="handleClick2">
					<el-tab-pane label="基本信息" name="first">
						<el-form>
							<el-form label-width="100px">
								<el-form-item :label= "$t('message.table.name')" prop="name" :required="false" style="width: 45%;float: left;">
									<el-input style="" value="标题块"></el-input>
								</el-form-item>
								<el-form-item label="描述" prop="description" :required="false" style="width: 45%;float: left;">
									<el-input style=";" value="标题块"></el-input>
								</el-form-item>		
								<el-form-item label="可见" prop="description" :required="false" style="width: 45%;float: left;">
									<el-input style=";" value="是"></el-input>
								</el-form-item>	
								<el-form-item style="width: 100%;float: left;">
									<el-button type="primary" >{{$t('message.button.release')}}</el-button>
									<el-button >{{$t('message.button.reset')}}</el-button>
								</el-form-item>
							</el-form>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="属性管理-首页" name="second">
						<el-table size="small" stripe :data="P1AttrData" style="width: 100%;margin-top:20px;"
						 height="300" @row-click="rowContentClick">
							<el-table-column prop="col1" :label= "$t('message.table.name')" width="100"></el-table-column>
							<el-table-column prop="col2" label="描述"></el-table-column>
							<el-table-column prop="col3" :label= "$t('message.table.type')"></el-table-column>
							<el-table-column prop="col4" label="是否可见"></el-table-column>
							<el-table-column prop="col5" label="数据库字段"></el-table-column>
						</el-table>							
					</el-tab-pane>
					<el-tab-pane label="属性管理-副页" name="third">
						<el-table size="small" stripe :data="P2AttrData" style="width: 100%;margin-top:20px;"
						 height="300">
							<el-table-column prop="col1" :label= "$t('message.table.name')" width="100"></el-table-column>
							<el-table-column prop="col2" label="描述"></el-table-column>
							<el-table-column prop="col3" :label= "$t('message.table.type')"></el-table-column>
							<el-table-column prop="col4" label="是否可见"></el-table-column>
							<el-table-column prop="col5" label="数据库字段"></el-table-column>
						</el-table>							
					</el-tab-pane>
					<el-tab-pane label="属性管理-第三页" name="four">
						<el-table size="small" stripe :data="P3AttrData" style="width: 100%;margin-top:20px;"
						 height="300">
							<el-table-column prop="col1" :label= "$t('message.table.name')" width="100"></el-table-column>
							<el-table-column prop="col2" label="描述"></el-table-column>
							<el-table-column prop="col3" :label= "$t('message.table.type')"></el-table-column>
							<el-table-column prop="col4" label="是否可见"></el-table-column>
							<el-table-column prop="col5" label="数据库字段"></el-table-column>
						</el-table>							
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
		
		<!-- 弹出修改框 -->
		<el-dialog title="属性管理" :visible.sync="dialogFormVisible">
		  <el-form :model="P1AttrData_edit">
		    <el-form-item :label= "$t('message.table.name')" :label-width="formLabelWidth" >
		      <el-input v-model="P1AttrData_edit.name" autocomplete="off" style="width: 80%;"></el-input>
		    </el-form-item>
		    <el-form-item label="是否可见" :label-width="formLabelWidth" >
		      <el-select v-model="P1AttrData_edit.name2" :placeholder="$t('message.placeholder.select')" style="width: 80%;">
		        <el-option label="是" value="是"></el-option>
		        <el-option label="否" value="否"></el-option>
		      </el-select>
		    </el-form-item>
			<el-form-item label="描述" :label-width="formLabelWidth" >
			  <el-input v-model="P1AttrData_edit.name3" autocomplete="off" style="width: 80%;"></el-input>
			</el-form-item>
			<el-form-item :label= "$t('message.table.type')" :label-width="formLabelWidth" >
			  <el-input v-model="P1AttrData_edit.name4" autocomplete="off" style="width: 80%;"></el-input>
			</el-form-item>
			<el-form-item label="数据库字段" :label-width="formLabelWidth" >
			  <el-input v-model="P1AttrData_edit.name5" autocomplete="off" style="width: 80%;"></el-input>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">{{$t('message.button.cancel')}}</el-button>
		    <el-button type="primary" @click="submitP1AttrDataForm">{{$t('message.button.affirm')}}</el-button>
		  </div>
		</el-dialog>
	</div>

</template>
<style scoped>
	.el-tree {
	    display: inline-block;
	 
	     min-width: 100%;
	 
	  }
</style>

<script>
	export default {
		data() {
			return {
				formLabelWidth: '120px',
				dialogFormVisible: false,
				P1AttrData_edit: {
				          name: '',
				          name2: '',
				          name3: '',
				          name4: '',
				          name5: "",
				        },
				P1AttrData_edit_Num:0,
				
				HistoryData:[],
				activeName: 'second',
				activeName2: 'second',
				data1: [{
					label: '物料',
					children: [{
						label: '电感类',
						children: [{
							label: '变压器'
						},{
							label: '磁珠'
						},{
							label: '电感'
						}]
					},{
						label: 'PCB',
						children: [{
							label: 'SDT PCB'
						},{
							label: 'SSD PCB'
						},{
							label: '工控机 PCB'
						},{
							label: '内存 PCB'
						},{
							label: '手机 PCB'
						},{
							label: '芯片基板'
						},{
							label: '移动硬盘 PCB'
						}]
					}]
				}, {
					label: '成品/半成品',
					children: [{
						label: 'eMMC卡',
						children: [{
							label: 'Assy'
						},{
							label: 'Test'
						}]
					}, {
						label: 'PCBA',
						children: [{
							label: 'SSD'
						},{
							label: '内存'
						}]
					}]
				}, {
					label: '文档',
					children: [{
						label: 'DOC',
						children: [{
							label: '初始需求'
						},{
							label: '产品规划'
						},{
							label: '产品开发'
						},{
							label: '代工文档'
						},{
							label: '通用文档'
						}]
					}, {
						label: 'SXF',
						children: [{
							label: 'BOM'
						},{
							label: 'ID图'
						},{
							label: 'MD图'
						},{
							label: 'PCB图'
						}]
					}]
				}],
				TabsData: [{
					col1: "标题块",
					col2: "标题块",
					col3: "是",
				},{
					col1: "变更",
					col2: "变更",
					col3: "是",
				},{
					col1: "BOM",
					col2: "BOM",
					col3: "是",
				},{
					col1: "制造商",
					col2: "制造商",
					col3: "是",
				},{
					col1: "质量",
					col2: "质量",
					col3: "否",
				},{
					col1: "关系",
					col2: "关系",
					col3: "是",
				},{
					col1: "附件",
					col2: "附件",
					col3: "是",
				},{
					col1: "操作历史",
					col2: "操作历史",
					col3: "是",
				}],
				LifecycleData: [{
					col1: "Inactive",
					col2: "Inactive",
					col3: "Yes",
				},{
					col1: "Obselete",
					col2: "Obselete",
					col3: "Yes",
				},{
					col1: "Pilot",
					col2: "Pilot",
					col3: "Yes",
				},{
					col1: "Prototype",
					col2: "Prototype",
					col3: "Yes",
				},{
					col1: "Preliminary",
					col2: "Preliminary",
					col3: "Yes",
				},{
					col1: "Production",
					col2: "Production",
					col3: "Yes",
				}],	
				P1AttrData: [{//页签-属性管理首页
					col1: "编号",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_item.item_number",	
					list_id:"0",
				},{
					col1: "部件类型",
					col2: "",
					col3: "列表",
					col4: "是",
					col5: "/pmdm_item.subclass_id",
					list_id:"1",
				},{
					col1: "生命周期阶段",
					col2: "",
					col3: "列表",
					col4: "是",
					col5: "/pmdm_item.lifecycle",
					list_id:"2",
				},{
					col1: "版本发放日期",
					col2: "",
					col3: "日期",
					col4: "是",
					col5: "/pmdm_item.release_date",	
					list_id:"3",
				},{
					col1: "描述",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_item.description",
					list_id:"4",
				},{
					col1: "产品线",
					col2: "",
					col3: "多选",
					col4: "是",
					col5: "/pmdm_item.product_lines",
					list_id:"5",
				}],
				
				P2AttrData: [{
					col1: "文本01",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text01",					
				},{
					col1: "文本02",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text02",					
				},{
					col1: "文本03",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text03",					
				},{
					col1: "文本04",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text04",					
				},{
					col1: "文本05",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text05",					
				},{
					col1: "文本06",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text06",					
				},{
					col1: "文本07",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text07",					
				},{
					col1: "文本08",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text08",					
				},{
					col1: "文本09",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text09",					
				},{
					col1: "文本10",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_two.text10",					
				}],
				P3AttrData: [{
					col1: "文本01",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text01",					
				},{
					col1: "文本02",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text02",					
				},{
					col1: "文本03",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text03",					
				},{
					col1: "文本04",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text04",					
				},{
					col1: "文本05",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text05",					
				},{
					col1: "文本06",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text06",					
				},{
					col1: "文本07",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text07",					
				},{
					col1: "文本08",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text08",					
				},{
					col1: "文本09",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text09",					
				},{
					col1: "文本10",
					col2: "",
					col3: "文本",
					col4: "是",
					col5: "/pmdm_page_three.text10",					
				}],
				defaultProps: {
					children: 'children',
					label: 'label'
				}
			};
		},
		methods: {
			handleNodeClick(data) {
				//console.log(data);
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleClick2(tab, event) {
				console.log(tab, event);
			},
			rowContentClick(row, column, event) {
				// P1AttrData
				this.dialogFormVisible = true;
				//console.log(this.P1AttrData_edit);
				this.P1AttrData_edit_Num = row.list_id;
				this.P1AttrData_edit.name = row.col1;
				this.P1AttrData_edit.name2 = row.col4;
				this.P1AttrData_edit.name3 = row.col2;
				this.P1AttrData_edit.name4 = row.col3;
				this.P1AttrData_edit.name5 = row.col5;
				
			},
			submitP1AttrDataForm() {
				this.dialogFormVisible = false;
				//alert("!");
				var Num = this.P1AttrData_edit_Num;
				this.P1AttrData[Num].col1 =this.P1AttrData_edit.name ;
				this.P1AttrData[Num].col4 =this.P1AttrData_edit.name2 ;
				this.P1AttrData[Num].col2 =this.P1AttrData_edit.name3 ;
				this.P1AttrData[Num].col3 =this.P1AttrData_edit.name4 ;
				this.P1AttrData[Num].col5 =this.P1AttrData_edit.name5 ;
			},
		},
		created() {}
	}
</script>
